<template>
    <section v-if="hasPermissions(['QC-Inspection Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }} - {{ parent.title }}
            <a v-if="parent.completed_date" class="inspection__status_success" v-html="'Completed at ' + parent.completed_date" style="color:#28a745; background-color: transparent; text-decoration: none; cursor: default; font-weight:bold;" />
            <a v-else class="inspection__status" v-html="'Incomplete'" style="color:#E1331A; background-color: transparent; text-decoration: none; cursor: default;" />
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Select an Associate name, select any Fail or N/A scores. If you do not want to Require correction, click the Override icon. If you are using a device, you may have the Associate sign the inspection.
            </p>
        </div>

        <div class="inspection">
            <div class="inspection__grid">
                <div class="row mb-0">
                    <div class="col-md-8">
                        <div class="row mb-0">
                            <div class="col-md-4 formdynamic__item__field">
                                <label class="modal-label" v-html="'Title:'"/>
                                <input type="text" :value="parent.title" class="input-field" style="font-size: 13px; height: 32px;" disabled/>
                            </div>
                            <div class="col-md-4 formdynamic__item__field" v-if="parent.inspection_type_id == 2">
                                <label class="modal-label" v-html="'Room Type:'"/>
                                <input type="text" :value="parent.room_types" class="input-field" style="font-size: 13px; height: 32px;" disabled/>
                            </div>
                            <div class="col-md-4 formdynamic__item__field">
                                <label class="modal-label" v-html="'Room:'"/>
                                <select class="input-field custom-select" style="font-size: 13px; height: 32px;" v-model="master_room_id">
                                    <option value="" v-html="'Select an option'"/>
                                    <option v-for="(item, i) in parent.rooms" :key="i" :value="item.id" v-html="`${item.name} (${item.completed_date ? 'Completed' : 'Incompleted'})`"/>
                                </select>
                            </div>
                            <div class="col-md-4 formdynamic__item__field">
                                <label class="modal-label" v-html="'Passing percentage:'"/>
                                <input type="text" class="input-field" style="font-size: 13px; height: 32px;" disabled :value="`${global_passing_percentage}%`"/>
                            </div>
                           <div class="col-md-4 formdynamic__item__field">  <!-- <div class="col-md-6 formdynamic__item__field"> -->
                                <label class="modal-label" v-html="'Individual passing percentage'"/>
                                <input type="text" class="input-field" style="font-size: 13px; height: 32px;" disabled :value="`${passing_percentage}%`"/>
                            </div>
                            <div class="col-md-4 formdynamic__item__field">
                                <label class="modal-label" v-html="'Inspection date:'"/>
                                <input type="date" :value="parent.date" class="input-field" style="font-size: 13px; height: 32px;" disabled/>
                            </div>
                            <div class="col-md-4 formdynamic__item__field">
                                <label class="modal-label" v-html="'Associate:'"/>
                                <select class="input-field custom-select" style="font-size: 13px; height: 32px;" v-model="room.associate_id" :disabled="isDisabled()">
                                    <option value="" v-html="'Select an option'"/>
                                    <option v-for="(item, i) in array_options.associates" :key="i" :value="item.id" v-html="`${item.name}`"/>
                                </select>
                            </div>
                            <form class="col-md-12 py-0" @submit.prevent="uploadInspectionRoomImages()" v-if="hasPermissions(['QC-Inspection Upload Room Images'])">
                                <div class="row">
                                    <div class="col-md-8 py-0">
                                        <FormDynamic 
                                            :form_format="form_format"
                                            :form_data="form_data"
                                            :array_options="array_options"
                                        />
                                    </div>
                                    <button class="modal__buttons__item w-auto px-3 mt-3" style="height: 30px" v-html="'Upload Images'" type="submit" :disabled="!this.form_data.new_inspection_room_images.length" :class="{'disabled button__disabled' : !this.form_data.new_inspection_room_images.length}"/>
                                    <button  class="modal__buttons__item w-auto px-3 mt-3" style="height: 30px" v-html="`See attached images (${room_images_count})`" type="button" @click="openImagesModal()"/>
                                </div>
                            </form>
                            <div class="col-md-12 py-0 pl-0 mb-4" v-else>
                                <button  class="modal__buttons__item w-auto px-3 mt-3" style="height: 30px" v-html="`See attached images (${room_images_count})`" type="button" @click="openImagesModal()"/>
                            </div>
                            <InspectionRoomImagesModal
                                :breadcrumb="breadcrumb"
                                :inspection_room_images="inspection_room_images"
                                :index_active="index_active"
                                :is_loading_images="is_loading_images"
                                @removeRoomImage="removeRoomImage($event)"
                                @nextImage="nextImage($event)"
                                @previousImage="previousImage($event)"
                            />
                            <div class="col-md-4 formdynamic__item__field">
                                <a v-if="room.completed_date" class="inspection__status_success" v-html="'Room Completed'" style="color:#28a745; background-color: transparent; text-decoration: none; cursor: default; font-weight:bold;" />
                                <a v-else class="inspection__status" v-html="'Room Incompleted'" style="color:#E1331A; background-color: transparent; text-decoration: none; cursor: default;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="table-responsive inspection__table" style="margin-top:0px;">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col" v-for="(item, i) in table_headers" :key="i" v-html="item.name"/>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in master_step_codes" :key="i">
                                <td v-html="master_room_name"/>
                                <td v-html="item.name"/>
                                <td scope="col">
                                <img src="/assets/img/svg/override-icon.svg" class="iconHistory" alt="History" @click="!parent.status ? overrideItem(i) : null">
                                </td>
                                <td>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`requirescorrection${i}`" type="checkbox" class="custom-control-input" v-model="item['require_correction']" disabled />
                                        <label :for="`requirescorrection${i}`" class="custom-control-label ml-2"/>
                                    </span>
                                </td>
                                <td>
                                    <select class="input-field custom-select" style="font-size: 13px; height: 32px;" v-model="item['associate_id']" @change="!isDisabled() ? listener(i, 'associate_id', item['associate_id']) : ''" :disabled="isDisabled()" >
                                        <option value="" v-html="'Select an option:' + item['associate_id']"/>
                                        <option v-for="(prop, j) in array_options.associates" :key="j" :value="prop.id" v-html="prop.name"/>
                                    </select>
                                </td>
                                <td>
                                    <div class="d-inline-block">
                                        <div v-for="(prop, j) in score_data" :key="j" class="form-check custom-control-inline">
                                            <input 
                                                class="form-check-input" 
                                                type="radio"
                                                :name="`score${i}`"
                                                v-model="item.score" 
                                                :id="`radio${i}`"
                                                :value="prop.id"
                                                @change="!parent.status ? listener(i, 'score', item.score) : null"
                                                :disabled="isDisabled()"
                                            />
                                            <label 
                                                :ref="`radio${i}`"
                                                :class="'ml-1 mt-1 form-check-label'" 
                                                v-html="prop.name"
                                            />
                                        </div> 
                                    </div>
                                </td>
                                <td>                                
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`corrected${i}`" type="checkbox" class="custom-control-input" v-model="item['corrected']" @change="!isDisabled() ?  listener(i, 'corrected', item['corrected']) : null" :disabled="isDisabled()"/>
                                        <label :for="`corrected${i}`" class="custom-control-label ml-2"/>
                                    </span>
                                </td>
                                <td>
                                    <input type="text" class="" maxlength="100" placeholder="Comment here..." v-model="item['comment']" @change="!isDisabled() ? listener(i, 'comment', item['comment']) : null" :disabled="isDisabled()"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row mb-0 inspection__cards">
                <div class="py-lg-0 col-md-6">
                    <div class="card cardModuleM h-100">
                        <div class="card-content">
                            <h2 class="subtitle--1 mb-2" v-html="'Associates'"/>
                            <VueSignaturePad :width="width" height="200px" ref="signaturePad"/>
                            <div class="text-right" v-show="!room.completed_date || !room.employee_firm">
                                <i class="material-icons prefix mr-3" @click="clear_firm()">
                                    <img class="iconCard" src="/assets/img/svg/iconmonstr-reload-thin.svg" data-toggle="tooltip" data-placement="top" title="Clear Employee Signature">
                                </i>        
                                <i class="material-icons prefix" @click="updateFirmAndComment(false)">
                                    <img class="iconCard" src="/assets/img/svg/iconmonstr-check-mark-thin.svg" data-toggle="tooltip" data-placement="top" title="Save Employee Signature">
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="py-lg-0 col-md-6">
                    <div class="card cardModuleM h-100">
                        <div class="card-content">
                            <h2 class="subtitle--1 mb-2" v-html="'Manager comments'"/>
                            <textarea class="card-content__tex text-area" cols="30" rows="10" maxlength="500" v-model="room.manager_comment" :disabled="room.completed_date && room.manager_comment"/>
                            <div class="text-right mt-3" v-show="!room.completed_date || !room.manager_comment">          
                                <i class="material-icons prefix" @click="updateFirmAndComment(true)">
                                    <img class="iconCard" src="/assets/img/svg/iconmonstr-check-mark-thin.svg" data-toggle="tooltip" data-placement="top" title="Save Manager Comment">
                                </i>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <!-- v-if="!parent.status -->
            <div class="modal__buttons d-md-flex justify-content-md-end" v-if="!isDisabled()">
                <button class="modal__buttons__item" v-html="`Complete`" @click="complete_inspection(true)"/>
            </div>
        </div>

        <ConfirmationModal
            :message="'Inspection completion submitted successfully.'"
            :second_message="'Would you like to return to Inspections main view?'"
            @ConfirmEmition="back_to()"
        />

        <AssociateSelectionModal
            :breadcrumb="breadcrumb"
            :array_options="array_options"
            @complete_inspection="sendInspectionReport($event)"
        />

        <MailInspectionModal
            :param_id="param_id"  
            :breadcrumb="breadcrumb"
            :data="data"
            :rest_api="lite_rest_api"
            ref="mail_inspection_modal"
        />

        <AssociateWarningModal
            :breadcrumb="breadcrumb"
            @complete_inspection="complete_inspection($event)"
        />

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <WaitingModal/>
    </section>
</template>

<script>
import axios                    from    'axios';
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal             from    '@/components/WaitingModal'
import AssociateSelectionModal  from    '../AssociateSelectionModal'
import AssociateWarningModal    from    './AssociateWarningModal'
import Resources                from    './resources'
import Methods                  from    './methods'
import DeletionModal            from    '@/components/DeletionModal'
import ConfirmationModal        from    '@/components/ConfirmationModal.vue'
import MailInspectionModal      from './MailInspectionModal.vue'
import InspectionRoomImagesModal from './InspectionRoomImagesModal'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import FormDynamic from '../../../FormDynamic.vue';
import FormResources from './form_resources';
const notyf = new Notyf({
    duration: 8000,
})

export default {

    name: "TemplateInspectionComplete",

    mixins:[
        Methods,
    ],

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        ConfirmationModal,
        AssociateSelectionModal,
        AssociateWarningModal,
        MailInspectionModal,
        InspectionRoomImagesModal,
        FormDynamic
    },

    data() {
        return {
            notyf,
            axios,
            user:                   this.get_user(),
            param_id:               this.$route.params.id,
            parent:                 {},
            parent_id:              '',
            child_api:              '/master_step_code_rooms',
            title_page:             'Inspection',
            rest_api:               `inspections/${this.$route.params.id}`,
            current_url:            `/qc-inspections/${this.$route.params.id}`,
            lite_rest_api:          `inspections`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            score_data:             Resources.score_data,
            single_select:          false,
            master_room_id:         '',
            master_room_name:       '',
            table_selection:        [],
            search:                 '',
            global_index:           0,
            single_object:          {},
            master_step_codes:      [],
            mass_inspection_items: [],
            codes:                  [],
            array_options:          {},
            parent_array_options:   {},
            associate_counter:      0,
            index_active: 0,
            incial_comment:         '',
            global_passing_percentage: '',
            room: {},
            inspection_room_images: [],
            form_format: FormResources.form_format_for_inspection_room_images,
            form_data: FormResources.form_data_for_inspection_room_images,
            is_loading_images: false,
            room_images_count: 0,
            associate_id_selected_for_next_completions: undefined
        }
    },

    // watch: {

    // },

    async mounted()
    {
        if(this.hasPermissions(['QC-Inspection Read']))
        {
            await this.api_request()
            await this.gettingGlobalPassingPorcentage()
        }
        else
        {
            window.location.href = '/'
        }

        window.addEventListener('resize', this.resize)

        window.$('[data-toggle="tooltip"]').tooltip()
    },

     computed:{

        width()
        {
            return this.window_width > 1366 ? '840px' : '550px'
        },

        passing_percentage()
        {
            const score = this.master_step_codes.filter(item => item.score === 1).length

            const master = this.master_step_codes.filter(item => item.score !== 3).length

            console.log(score, master);

            return master ? parseInt((score / master) * 100) : 0
        },

        individual_passing_percentage()
        {
            const room = this.master_room_id ? this.parent.rooms.find(item => item.id === this.master_room_id) : null
            return room ? `${room.name} - passing percentage:` : ''
        },

    },
}

</script>

<style scoped>
    .text-area:focus-visible {
        outline: none;
    }
</style>